import React from 'react';


const IconClose: React.FC = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
            d="M2 3.62956L6.37045 8.00001L2 12.3705L3.62956 14L8.00001 9.62957L12.3705 14L14 12.3705L9.62957 8.00001L14 3.62956L12.3705 2L8.00001 6.37045L3.62956 2L2 3.62956Z"
            fill="#4D4E65" />
    </svg>


);

export default IconClose;